interface Status {
  title?: string;
  description?: string;
  link?: string;
}

export const useStatus = () => {
  return {
    status: null as Status | null,
  };
};
